import { render, staticRenderFns } from "./OtoTab.vue?vue&type=template&id=a42afc68&scoped=true"
import script from "./OtoTab.vue?vue&type=script&lang=js"
export * from "./OtoTab.vue?vue&type=script&lang=js"
import style0 from "./OtoTab.vue?vue&type=style&index=0&id=a42afc68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42afc68",
  null
  
)

export default component.exports